export const Any: any = {};
